import { signal } from "@preact/signals-react";

export const token = signal(null);
export const setToken = (value) => (token.value = value);
